'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg16 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 16, height: 17, viewBox: "0 0 16 17", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.74107 2.34685C4.10113 1.92807 4.7325 1.88047 5.15128 2.24053L11.2707 7.50195C11.2817 7.51142 11.2929 7.52099 11.3041 7.53066C11.4789 7.6808 11.6813 7.85457 11.8316 8.02592C12.0103 8.22948 12.2337 8.5584 12.2337 9.01846C12.2337 9.47853 12.0103 9.80744 11.8317 10.011C11.6813 10.1824 11.479 10.3561 11.3041 10.5063C11.2929 10.5159 11.2817 10.5255 11.2707 10.535L5.20674 15.7488C4.78796 16.1089 4.15659 16.0613 3.79653 15.6425C3.43646 15.2238 3.48405 14.5924 3.90283 14.2323L9.9668 9.01847L3.84738 3.75706C3.42861 3.397 3.38101 2.76563 3.74107 2.34685Z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg16;
//# sourceMappingURL=16.js.map
